export const enrichGuestCartItems = async (guestCartItems) => {
  if (!guestCartItems || guestCartItems.length === 0) return [];

  const enrichedItems = [];

  for (const item of guestCartItems) {
    try {
      if (item.item_type === "product") {
        const response = await fetch(
          `https://evercorenutrition.com/ev_admin/api/products/${item.product_id}/`
        );

        if (response.ok) {
          const productData = await response.json();

          const variant = productData.variants?.find(
            (v) => String(v.id) === String(item.variant_id)
          );

          const sellingPrice = parseFloat(
            variant?.selling_price ||
              variant?.price ||
              productData.selling_price ||
              0
          );

          const originalPrice = parseFloat(
            variant?.mrp ||
              variant?.price ||
              productData.mrp ||
              productData.price ||
              sellingPrice
          );

          enrichedItems.push({
            ...item,
            name: productData.name,
            product_name: productData.name,
            main_image: variant?.main_image || productData.main_image,
            image: variant?.main_image || productData.main_image,

            unit_price: sellingPrice,
            price: sellingPrice,
            original_mrp: originalPrice,
            variant_mrp: originalPrice,

            variant_name: variant?.display_name || variant?.flavour || "",
            item_type: "product",
          });
        } else {
          enrichedItems.push(item);
        }
      } else if (item.item_type === "combo") {
        const response = await fetch(
          `https://evercorenutrition.com/ev_admin/api/combos/${item.combo_id}/`
        );

        if (response.ok) {
          const comboData = await response.json();
          const combo = comboData.combo || comboData;

          const sellingPrice = parseFloat(
            combo.selling_price || combo.discount_price || 0
          );

          const originalPrice = parseFloat(
            combo.mrp || combo.price || combo.original_price || sellingPrice
          );

          enrichedItems.push({
            ...item,
            name: combo.name,
            main_image: combo.image_url || combo.image,
            image: combo.image_url || combo.image,

            unit_price: sellingPrice,
            price: sellingPrice,
            original_mrp: originalPrice,
            variant_mrp: originalPrice,

            item_type: "combo",
          });
        } else {
          enrichedItems.push(item);
        }
      } else {
        enrichedItems.push(item);
      }
    } catch (error) {
      console.error("Error enriching item:", error);
      enrichedItems.push(item);
    }
  }

  return enrichedItems;
};